import { useBusinessEntity } from '@zenbusiness/application-commons-business-entity';
import { useLinkPressedCallback } from '@zenbusiness/application-commons-clickstream';
import { FormattedMessage, useIntl } from '@zenbusiness/application-commons-intl';
import ContentHeader from '@zenbusiness/zui/ContentHeader';
import Text from '@zenbusiness/zui/Text';

import { generateZenUrl } from '#client/utils/urls';

import * as Styled from './TaxAdviceCard.styles';

const TaxAdviceCard = () => {
  const { businessEntityUuid } = useBusinessEntity();
  const { formatMessage: fm } = useIntl();

  const destination = generateZenUrl(`/dashboard/${businessEntityUuid}/money/tax-services/`);

  const trackLinkPressed = useLinkPressedCallback({
    elementName: 'carousel_link',
    elementText: 'tax_advice',
    destination
  });

  return (
    <Styled.Root>
      <Styled.Image
        alt={fm({ id: 'dashboard.carousel.card.taxAdvice.imageAlt' })}
        src="/s2/raster/accountant-desk-working.jpg"
      />
      <Styled.CardContent>
        <ContentHeader
          title={<Text size="md" weight="medium" color="primary"><FormattedMessage id="dashboard.carousel.card.taxAdvice.title" /></Text>}
          subtitle={<Text size="sm" weight="regular" color="secondary"><FormattedMessage id="dashboard.carousel.card.taxAdvice.subTitle" /></Text>}
        >
          <Styled.CardButton color="secondary" size="sm" href={destination} onClick={trackLinkPressed}><FormattedMessage id="dashboard.carousel.card.taxAdvice.button" /></Styled.CardButton>
        </ContentHeader>
      </Styled.CardContent>

    </Styled.Root>
  );
};

export default TaxAdviceCard;
